export default {
  'OrderEvent.Button': ({ inspectionId }) => {
    window.open(`/inspections/${inspectionId}`, "_blank");
  },
};
